export default {
    mapper: {},
};
